import React, { useState } from "react";
import { FaComments } from "react-icons/fa";
import { FaHandshake, FaUserPlus } from "react-icons/fa6"; // icons for proposal & connection
import { useLocation, useNavigate } from "react-router-dom";
const Chats = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();
  const users = [
    { id: 1, name: "Ali Raza", lastMessage: "Hello, I need help." },
    { id: 2, name: "Sara Khan", lastMessage: "My account issue." },
    { id: 3, name: "John Doe", lastMessage: "Payment not working." },
  ];

  const openChat = (user) => {
    setSelectedUser(user);
    setIsOpen(true);
  };

  const closeChat = () => {
    setIsOpen(false);
    setSelectedUser(null);
  };

  // Example handlers
  const handleProposal = (user) => {
    alert(`Send Proposal to ${user.name}`);
  };

  const handleConnection = (user) => {
    alert(`Send Connection to ${user.name}`);
  };

  const createProfileHandler = () => {
    console.log("clicked")
    navigate("/registration"); 
  }
  return (
    <div className="p-6 bg-gray-100 min-h-screen w-full">
 
        <h2 className="text-xl font-bold mb-4">Chats</h2>


      {/* Users List */}
      <div className="bg-white rounded-lg shadow p-4">
        {users.map((user) => (
          <div
            key={user.id}
            className="flex items-center justify-between border-b py-3"
          >
            <div>
              <p className="font-semibold">{user.name}</p>
              <p className="text-sm text-gray-500">{user.lastMessage}</p>
            </div>

            <div className="flex gap-2">
              {/* Chat Button */}
              {/* <button
                onClick={() => openChat(user)}
                className="text-blue-500 hover:text-blue-700"
                title="Open Chat"
              >
                <FaComments size={20} />
              </button> */}
              <button
                onClick={() => openChat(user)}
                className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg shadow-md transition duration-200"
              >
                <FaComments size={20} />
                <span>Chat</span>
              </button>

              {/* Proposal Button */}
              {/* <button
                onClick={() => handleConnection(user)}
                className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg shadow-md transition duration-200"
              >
                <FaUserPlus size={18} />
                <span>Send Connection</span>
              </button> */}

              {/* Connections Button */}
              {/* <button
                onClick={() => handleConnection(user)}
                className="text-purple-500 hover:text-purple-700"
                title="Add Connection"
              >
                <FaUserPlus size={20} />
              </button> */}
            </div>
          </div>
        ))}
      </div>

      {/* Chat Modal */}
      {isOpen && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl flex flex-col h-[80vh]">
            {/* Header */}
            <div className="p-4 border-b flex justify-between items-center">
              <h3 className="font-bold text-lg">
                Chat with {selectedUser.name}
              </h3>
              <button onClick={closeChat} className="text-red-500 font-bold">
                ✕
              </button>
            </div>

            {/* Chat Messages */}
            <div className="flex-1 p-4 overflow-y-auto space-y-3 bg-gray-50">
              {/* Incoming */}
              <div className="flex">
                <div className="bg-gray-200 p-2 rounded-lg max-w-xs">
                  Hello, I need help.
                </div>
              </div>
              {/* Outgoing */}
              <div className="flex justify-end">
                <div className="bg-blue-500 text-white p-2 rounded-lg max-w-xs">
                  Sure, how can I assist you?
                </div>
              </div>
            </div>

            {/* Input Box */}
            <div className="p-3 border-t flex items-center gap-2">
              <input
                type="text"
                placeholder="Type your message..."
                className="flex-1 p-2 border rounded-md"
              />
              <button className="bg-blue-500 text-white px-4 py-2 rounded-md">
                Send
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chats;
